import styled from "styled-components";

const DefaultText = styled.label(({ color, size, ...props }) => ({
  lineHeight: "20px",
  fontSize: size || 14,
  fontWeight: 400,
  margin: 0,
  wordBreak: "normal",
  color: color || props.theme.color.navy,
  textAlign: "center",
  fontFamily: "Rubik",
}));

const Error = styled(DefaultText)`
  color: red;
`;

const Heading = styled(DefaultText)(({ color, ...props }) => ({
  fontWeight: 700,
  color: color || props.theme.color.navy,
}));

const Body = styled(DefaultText)(({ color, ...props }) => ({
  fontSize: 16,
  color: color || props.theme.color.navy,
}));

const Small = styled(DefaultText)(({ color, ...props }) => ({
  fontSize: 14,
  color: color || props.theme.color.navy,
}));

const Smaller = styled(DefaultText)(({ color, ...props }) => ({
  fontSize: 12,
  color: color || props.theme.color.navy,
}));

const Heading1 = styled(Heading)(({ ...props }) => ({
  fontWeight: 700,
  fontSize: 36,
}));

const Heading2 = styled(Heading)(({ ...props }) => ({
  fontWeight: 700,
  fontSize: 28,
}));

const Heading3 = styled(Heading)(({ ...props }) => ({
  fontWeight: 700,
  fontSize: 24,
}));

const Heading4 = styled(Heading)(({ ...props }) => ({
  fontWeight: 700,
  fontSize: 20,
}));

const Heading5 = styled(Heading)(({ ...props }) => ({
  fontWeight: 700,
  fontSize: 18,
}));

const Heading6 = styled(Heading)(({ ...props }) => ({
  fontWeight: 700,
  fontSize: 14,
}));

const SmallRegular = styled(Small)(({ ...props }) => ({
  fontWeight: 400,
}));

const SmallerRegular = styled(Smaller)(({ ...props }) => ({
  fontWeight: 400,
}));

const SmallerBold = styled(Smaller)(({ ...props }) => ({
  fontWeight: 500,
}));

const BodyRegular = styled(Body)(({ ...props }) => ({
  fontWeight: 400,
}));

const SmallMeduim = styled(Small)(({ ...props }) => ({
  fontWeight: 500,
}));

const BodyMeduim = styled(Body)(({ ...props }) => ({
  fontWeight: 500,
}));

const SmallBold = styled(Small)(({ ...props }) => ({
  fontWeight: 700,
}));

const BodyBold = styled(Body)(({ ...props }) => ({
  fontWeight: 700,
}));

const TextFactory = ({ variant, theme, color, size, ...props }) => {
  const vars = {
    h1: <Heading1 color={color} {...props} />,
    h2: <Heading2 color={color} {...props} />,
    h3: <Heading3 color={color} {...props} />,
    h4: <Heading4 color={color} {...props} />,
    h5: <Heading5 color={color} {...props} />,
    h6: <Heading6 color={color} {...props} />,
    sr: <SmallRegular color={color} {...props} />,
    sm: <SmallMeduim color={color} {...props} />,
    smr: <SmallerRegular color={color} {...props} />,
    smrb: <SmallerBold color={color} {...props} />,
    sb: <SmallBold color={color} {...props} />,
    br: <BodyRegular color={color} {...props} />,
    bm: <BodyMeduim color={color} {...props} />,
    bb: <BodyBold color={color} {...props} />,

    error: <Error {...props} />,
  };
  return vars[variant] || <DefaultText color={color} size={size} {...props} />;
};

const Text = ({ v, color, ...props }) => (
  <TextFactory {...props} variant={v} color={color} />
);

Text.H1 = ({ v = "h1", color, ...props }) => (
  <TextFactory {...props} variant={v} color={color} />
);
Text.H2 = ({ v = "h2", color, ...props }) => (
  <TextFactory {...props} variant={v} color={color} />
);
Text.H3 = ({ v = "h3", color, ...props }) => (
  <TextFactory {...props} variant={v} color={color} />
);
Text.H4 = ({ v = "h4", color, ...props }) => (
  <TextFactory {...props} variant={v} color={color} />
);
Text.H5 = ({ v = "h5", color, ...props }) => (
  <TextFactory {...props} variant={v} color={color} />
);
Text.H6 = ({ v = "h6", color, ...props }) => (
  <TextFactory {...props} variant={v} color={color} />
);
Text.SR = ({ v = "sr", color, ...props }) => (
  <TextFactory {...props} variant={v} color={color} />
);
Text.SM = ({ v = "sm", color, ...props }) => (
  <TextFactory {...props} variant={v} color={color} />
);
Text.SMR = ({ v = "smr", color, ...props }) => (
  <TextFactory {...props} variant={v} color={color} />
);
Text.SMRB = ({ v = "smrb", color, ...props }) => (
  <TextFactory {...props} variant={v} color={color} />
);
Text.SB = ({ v = "sb", color, ...props }) => (
  <TextFactory {...props} variant={v} color={color} />
);
Text.BR = ({ v = "br", color, ...props }) => (
  <TextFactory {...props} variant={v} color={color} />
);
Text.BM = ({ v = "bm", color, ...props }) => (
  <TextFactory {...props} variant={v} color={color} />
);
Text.BB = ({ v = "bb", color, ...props }) => (
  <TextFactory {...props} variant={v} color={color} />
);
Text.Error = ({ v = "error", color, ...props }) => (
  <TextFactory {...props} variant={v} color={color} />
);

Text.H1.displayName = "Heading1";
Text.H2.displayName = "Heading2";
Text.H3.displayName = "Heading3";
Text.H4.displayName = "Heading4";
Text.H5.displayName = "Heading5";
Text.SR.displayName = "Small/Regular";
Text.SM.displayName = "Small/Meduim";
Text.SMR.displayName = "Smaller/Regular";
Text.SMRB.displayName = "Smaller/Bold";
Text.SB.displayName = "Small/Bold";
Text.BR.displayName = "Body/Regular";
Text.BM.displayName = "Body/Meduim";
Text.BB.displayName = "Body/Bold";
Text.Error.displayName = "Error";

export default Text;
